import React from 'react'
import { withOktaAuth } from "@okta/okta-react";
import Section from "./Section";
import {
  getSharepointContributorFileList,
  getContributor,
  getContributorSections,
} from "../../helpers/api";
import EntityList from "./SectionEntityList";
import Files from "./SectionFiles";
import ProjectList from "./ProjectList";
import Readiness from "./SectionReadiness";
import { connect } from "react-redux";
import Processing from "../misc/processing";
import Placeholder from "../misc/placeholder";
import Sidebar from "./sidebar";
import { setSections, setContributor } from "../../actions/general";
import CountryExtraInfo from "./CountryExtraInfo";
import { CONSTANTS } from "../../helpers/constants";
import PrintButton from "../misc/printButton";
import Watermark from "../misc/watermark";
//import { Link } from 'react-router-dom'
class ContributorProfile extends React.Component {
  state = {
    id: this.props.match.params.id,
    contributor: null,
    readiness: null,
    sharepoint_files: [],
    confidential_pages: [],
    ready_sections: [],
    total_sections: 4, // refactor
  };

  checkIfReadyForPrinting = () => {
    const { contributor, sections, readiness, projects } = this.state;
    //console.log("ready?", contributor && contacts && entities && sections && readiness && projects ? true : false, { contributor, contacts, entities, sections, readiness, projects })
    this.setState({
      ready_print:
        contributor && sections && readiness && projects ? true : false,
    });
  };

  signalReady = (mod) => {
    this.setState((prev) => ({
      ready_sections: [...prev.ready_sections, mod],
    }));
  };

  async getSharepointFiles() {
    const contributor = this.state.contributor;
    const files = await getSharepointContributorFileList(
      contributor.ISO3 || contributor.ContributorID
    );
    //console.log({ files })
    this.setState({
      sharepoint_files: files,
    });
  }

  fetchData = () => {
    getContributor(this.props.match.params.id).then((data) => {
      this.setState(
        {
          contributor: data,
        },
        () => {
          this.getSharepointFiles();
          this.props.setContributor(data);
          document.title = `${data.ContributorName} - ${CONSTANTS.APP_TITLE}`;
        },
        () => {
          this.checkIfReadyForPrinting();
        }
      );
    });
    getContributorSections(this.props.match.params.id).then((data) => {
      let sections = [];
      if (data && data.length > 0) {
        sections = data
          .filter((s) => s.ParentID === null)
          .map((section) => {
            section.Children = data
              .filter((s) => s.ParentID === section.ContributorSectionID)
              .map((c) => {
                c.Children = [];
                return c;
              });
            return section;
          });
        this.props.setSections(
          sections
            .filter(
              (s) => s.Markdown.trim().length > 1 || s.Children.length > 0
            )
            .map((s) => {
              return {
                label: s.ShortName || s.Title,
                id: s.ContributorProfileSectionID,
                confidential: s.Confidential,
              };
            })
        );
      }
      this.setState(
        {
          sections: sections,
        },
        () => {
          this.checkIfReadyForPrinting();
        }
      );
    });
  };

  componentDidMount() {
    document.body.classList.add("print-none");
    this.fetchData();
  }

  componentWillUnmount() {
    document.body.classList.remove("print-none");
  }

  render() {
    const {
      confidential_pages,
      contributor,
      id,
      sections,
      sharepoint_files,
      ready_sections,
      total_sections,
    } = this.state;
    //console.log("total sections", total_sections, "ready_sections", ready_sections.length)
    //console.log({ sharepoint_files })
    const { user } = this.props;

    if (!contributor || !user) {
      return <Processing />;
    }
    return (
      contributor &&
      user && (
        <React.Fragment>
          <div className="print-only">
            {/*<p><strong>CONTRIBUTOR PROFILE PAGE FOR {contributor.CountryName ? contributor.CountryName.toUpperCase() : ''}</strong></p>*/}
            <code className="print-only font-larger">
              CONFIDENTIAL: FOR INTERNAL USE ONLY
            </code>
          </div>

          {contributor.ISO2 && (
            <div className="container d-block d-sm-none mt-3">
              <div className="row">
                <div className="col">
                  <img
                    style={{ width: "100%", height: "auto" }}
                    className="flag-main mt-1 mb-3"
                    src={`https://ipmsapplication.blob.core.windows.net/public/images/flags/v1/${(
                      contributor.ISO2 || ""
                    ).toLowerCase()}.png`}
                    alt={contributor.ISO3}
                  />
                  <hr />
                </div>
              </div>
            </div>
          )}

          <div className="container-fluid p-0 m-0">
            <div className="row no-gutters">
              <Sidebar />
              <div className="col">
                {/*<div className="jumbotron position-relative d-none d-sm-block">
                                <div className="container-fluid">
                                    <div className="row c-header">
                                        <div className="col-6">
                                            <h1 className="display-4">{contributor.CountryName}</h1>
                                            
                                        </div>
                                        <div className="col-6 text-right">
                                            <img className="flag-main" src={`https://ipmsapplication.blob.core.windows.net/public/images/flags/v1/${contributor.ISO2.toLowerCase()}.png`} alt={contributor.ISO3} />
                                        </div>
                                    </div>
                                </div>
                            </div>*/}
                <div className="main">
                  <div className="row">
                    <div className="col">
                      {contributor.ISO3 ? (
                        <h1 className="header main-header mb-4 mt-2">
                          {contributor.ContributorName}
                        </h1>
                      ) : (
                        <h1 className="header mb-4 mt-2">
                          {contributor.ContributorName}
                        </h1>
                      )}
                      <div className="form-group text-right print-none">
                        {/*<button disabled={!ready_print} type="button" className="btn btn-sm btn-secondary" onClick={() => this.print()}><i className="fas fa-print" /> {!ready_print ? 'Preparing...' : 'Print this page'}</button>*/}
                        <PrintButton
                          setWatermark={(ff) =>
                            this.setState({ confidential_pages: ff })
                          }
                          ready={
                            ready_sections.length === total_sections ||
                            (contributor.CountryName === null &&
                              ready_sections.length === 1)
                          }
                        />
                      </div>
                      {contributor.ContributorType === "Country" && (
                        <CountryExtraInfo contributor={contributor} />
                      )}
                    </div>
                    <div className="col text-right print-only">
                      {contributor.ISO2 && (
                        <img
                          className="flag-main flag-bordered"
                          src={`https://ipmsapplication.blob.core.windows.net/public/images/flags/v1/${(
                            contributor.ISO2 || ""
                          ).toLowerCase()}.png`}
                          alt={contributor.ISO3}
                        />
                      )}
                    </div>
                  </div>

                  {(!contributor || !sections || !user) && (
                    <React.Fragment>
                      <Placeholder />
                      <Placeholder />
                      <Placeholder />
                    </React.Fragment>
                  )}

                  {sections &&
                    sections.map((s) => (
                      <Section
                        key={s.ContributorSectionID}
                        Contributor={contributor}
                        countryId={id}
                        {...s}
                      ></Section>
                    ))}

                  {contributor.ContributorType === "Country" && (
                    <EntityList
                      signalReady={this.signalReady}
                      ContributorID={contributor.ContributorID}
                      type="ae"
                    />
                  )}

                  {contributor.ContributorType === "Country" && (
                    <div>
                      <a className="anchor" id="section-activities" href="/">
                        {" "}
                      </a>
                      <div className="d-none d-sm-block">
                        <ProjectList
                          signalReady={this.signalReady}
                          ContributorID={contributor.ContributorID}
                          stage="Approved"
                          Total={true}
                          Title="Funded Activities"
                          Subtitle={`By AEs headquartered in ${contributor.CountryName}`}
                        />

                        <ProjectList
                          signalReady={this.signalReady}
                          ContributorID={contributor.ContributorID}
                          stage="Pipeline"
                          Total={true}
                          Title="Projects Pipeline"
                          Subtitle={`By AEs headquartered in ${contributor.CountryName}`}
                        />
                      </div>
                      {/*<div className="d-sm-none">
                                        <ProjectListVertical data={projects && projects.filter(p => p.Stage === 'Approved')} Total={true} Title='Funded Activities' Subtitle={`By AEs headquartered in ${contributor.CountryName}`} />
                                        <ProjectListVertical data={projects && projects.filter(p => p.Stage === 'Pipeline')} Total={true} Title='Projects Pipeline' Subtitle={`By AEs headquartered in ${contributor.CountryName}`} />
                                    </div>

                                    <SectionTableList data={readiness} Title='Readiness Projects' Subtitle={`By AEs headquartered in ${contributor.CountryName}`} cols={readinessCols} Total={true} />
*/}
                      <Readiness
                        signalReady={this.signalReady}
                        contributor={contributor}
                      />
                    </div>
                  )}

                  <div>
                    <a href="/" className="anchor" id="section-files">
                      {" "}
                    </a>
                    {(sharepoint_files && Array.isArray(sharepoint_files) ? sharepoint_files : []).map((folder, idx) => (
                      <Files type={folder.id} key={idx} data={folder} />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Watermark count={confidential_pages} />
        </React.Fragment>
      )
    );
  }
}

const mapStateToProps = ({ okta }) => {
  return {
    user: okta.user,
    groups: okta.groups,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSections: (sections) => dispatch(setSections(sections)),
    setContributor: (data) => dispatch(setContributor(data)),
  };
};

export default withOktaAuth(
  connect(mapStateToProps, mapDispatchToProps)(ContributorProfile)
);